export default __webpack_public_path__ + "static/media/backup_and_dr.723cddac.svg";